import api from "../axios";
import Api from "../Api";

export async function bannerList() {
  const response = await api
    .get(`${Api.request.URL}/banner`)
    .then((res) => {
      //  const result = res.data.data.data.filter((x) => x.isVisible === 1);
      return res.data.data;
    })
    .catch((error) => {
      return error.response.data.msg;
    });
  return response;
}

export async function bannerById(id) {
  const response = await api
    .get(`${Api.request.URL}/banner/${id}`)
    .then((res) => {
      //  const result = res.data.data.data.filter((x) => x.isVisible === 1);
      return res.data.data;
    })
    .catch((error) => {
      return error.response.data.msg;
    });
  return response;
}


export async function uploadBanner(DataForm) {

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${Api.request.URL}/banner/upload`,
    data: DataForm,
  };

  const response = await api
    .request(config)
    .then((res) => {
     return res.data.msg;
    })
    .catch((error) => {
      console.log(error);
    });

  return response;
}




